import { Address } from '@src/main/modules/messages/domain/address/address.interface';

export interface CreateAddressRequest {
  email: string;
  description: string;
}

export const createRequestFromAddress = (address: Address): CreateAddressRequest => ({
  email: address.email,
  description: address.description,
});
